import React, { useCallback, memo } from "react";
import RatingDetails from "./RatingDetails";
import Button from "../UI/Button";
import { TableRow, TableCell } from "../UI/Table";
import "./RequestRow.css";

const getRatingNumericValueById = (ratings, id) => {
  let ratingNumericValue = 0;
  ratings.forEach((rating) => {
    if (rating.RatingId === id) {
      ratingNumericValue = rating.NumericResult;
    }
  });
  return ratingNumericValue;
};

const RequestRow = ({ request, isExpanded, onToggle, onViewDetails }) => {
  const {
    id,
    request_amount,
    request_type,
    eventId,
    accountName,
    eventDate,
    organizerVerified,
    ratingDetails,
  } = request;

  const handleExpandClick = useCallback(() => {
    onToggle(id);
  }, [onToggle, id]);

  const handleDetailsClick = useCallback(() => {
    onViewDetails(eventId);
  }, [onViewDetails, eventId]);

  return (
    <>
      <TableRow className="request-row">
        <TableCell>
          <Button
            variant="outline"
            size="small"
            onClick={handleExpandClick}
            className="expand-btn"
            aria-expanded={isExpanded}
            aria-label={isExpanded ? "Collapse ratings" : "Expand ratings"}
          >
            {isExpanded ? "−" : "+"}
          </Button>
        </TableCell>
        <TableCell className="request-row__id">{id}</TableCell>
        <TableCell className="request-row__amount">
          ${request_amount.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </TableCell>
        <TableCell>{request_type}</TableCell>
        <TableCell>{eventId}</TableCell>
        <TableCell className="request-row__account">{accountName}</TableCell>
        <TableCell>{new Date(eventDate).toLocaleDateString()}</TableCell>
        <TableCell>
          <span
            className={`verification-badge ${
              organizerVerified !== "Unverified" ? "verified" : "unverified"
            }`}
          >
            {organizerVerified !== "Unverified"
              ? organizerVerified
              : "Unverified"}
          </span>
        </TableCell>
        <TableCell>{getRatingNumericValueById(ratingDetails, 101)}</TableCell>

        <TableCell>
          <Button variant="primary" size="small" onClick={handleDetailsClick}>
            Details
          </Button>
        </TableCell>
      </TableRow>

      {isExpanded && (
        <TableRow className="request-row__expanded">
          <TableCell colSpan={10}>
            <RatingDetails ratings={ratingDetails} />
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default memo(RequestRow);
